/** FUNCTIONALITY-096 — local home tile contract (stable biz_* keys). Icons in labels. */
export const BUSINESS_HOME_TILES = [
  { id: "biz_ramen_buldak", label: "🍜 Рамени, бульдак" },
  { id: "biz_snacks", label: "🍘 Снеки" },
  { id: "biz_asian_tea", label: "🍵 Азійський чай, пуери" },
  { id: "biz_sauces", label: "🥢 Соуси" },
  { id: "biz_drinks", label: "🥤 Напої" },
  { id: "biz_desserts", label: "🍡 Десерти, цукор, мальтоза" },
  { id: "biz_fruit_concentrates", label: "🍋 Фруктові концентрати, основи для чаїв та лимонадів" },
  { id: "biz_pastes_spices", label: "🌶️ Пасти і спеції" },
  { id: "biz_rice_noodles", label: "🍚 Рис, локшина, борошно" },
  { id: "biz_spring_rolls", label: "🥟 Спринг-роли, тісто, вонтони" },
  { id: "biz_veg_fruit_preserve", label: "🥭 Овочі, фрукти, консервація" },
  { id: "biz_cooking_sets", label: "🍱 Набори для приготування" },
  { id: "biz_seaweed", label: "🌊 Водорості, норі, вакаме" },
  { id: "biz_coconut_milk", label: "🥥 Кокосове молоко" },
  { id: "biz_caviar_seafood", label: "🍣 Ікра, морепродукти" },
  { id: "biz_diet", label: "🥗 Дієтичні продукти" },
  { id: "biz_equipment", label: "🍳 Обладнання для азіатської кухні" },
] as const;

export type BusinessHomeTileId = (typeof BUSINESS_HOME_TILES)[number]["id"];
